import {EventType} from "@testing-library/react";

const ManualEventSetter = (eventType: EventType, input: any, value: any) => {
    const valueSetter = Object.getOwnPropertyDescriptor(input, 'value')?.set;
    const prototype = Object.getPrototypeOf(input);
    const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

    if (valueSetter && prototypeValueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(input, value);
    } else if(valueSetter) {
        valueSetter.call(input, value);
    }

    ManualEventOnly(eventType, input);
}

const ManualEventOnly = (eventType: EventType, input: any) => {
    input.dispatchEvent(new Event(eventType, { bubbles: true }));
}

export {
    ManualEventSetter,
    ManualEventOnly
}
